export default __webpack_public_path__ + "static/media/action-newTab_blue.ced198f6.svg";